_ = require("lodash")

PUTT_DISABLED_VALUE = '-'
PAR_VALUE_FOR_DISABLE_FAIRWAY = 3

teeOffClubOptions = [
  value: "dr"
  text: "1W"
,
  value: "2w"
  text: "2W"
,
  value: "3w"
  text: "3W"
,
  value: "4w"
  text: "4W"
,
  value: "5w"
  text: "5W"
,
  value: "6w"
  text: "6W"
,
  value: "7w"
  text: "7W"
,
  value: "8w"
  text: "8W"
,
  value: "9w"
  text: "9W"
,
  value: "10w"
  text: "10W"
,
  value: "11w"
  text: "11W"
,
  value: "12w"
  text: "12W"
,
  value: "13w"
  text: "13W"
,
  value: "14w"
  text: "14W"
,
  value: "15w"
  text: "15W"
,
  value: "h1"
  text: "U1"
,
  value: "h2"
  text: "U2"
,
  value: "h3"
  text: "U3"
,
  value: "h4"
  text: "U4"
,
  value: "h5"
  text: "U5"
,
  value: "h6"
  text: "U6"
,
  value: "h7"
  text: "U7"
,
  value: "h8"
  text: "U8"
,
  value: "h9"
  text: "U9"
,
  value: "hh2"
  text: "2H"
,
  value: "hh3"
  text: "3H"
,
  value: "hh4"
  text: "4H"
,
  value: "hh5"
  text: "5H"
,
  value: "hh6"
  text: "6H"
,
  value: "hh7"
  text: "7H"
,
  value: "hh8"
  text: "8H"
,
  value: "1i"
  text: "1i"
,
  value: "2i"
  text: "2i"
,
  value: "3i"
  text: "3i"
,
  value: "4i"
  text: "4i"
,
  value: "5i"
  text: "5i"
,
  value: "6i"
  text: "6i"
,
  value: "7i"
  text: "7i"
,
  value: "8i"
  text: "8i"
,
  value: "9i"
  text: "9i"
,
  value: "10i"
  text: "10i"
,
  value: "11i"
  text: "11i"
,
  value: "12i"
  text: "12i"
,
  value: "pw"
  text: "PW"
,
  value: "dw"
  text: "DW"
,
  value: "gw48"
  text: "GW"
,
  value: "gw"
  text: "AW"
,
  value: "sw"
  text: "SW"
,
  value: "sw54"
  text: "SW54"
,
  value: "sw55"
  text: "SW55"
,
  value: "sw56"
  text: "SW56"
,
  value: "sw57"
  text: "SW57"
,
  value: "sw58"
  text: "SW58"
,
  value: "lw"
  text: "LW"
,
  value: "lw60"
  text: "LW60"
,
  value: "lw61"
  text: "LW61"
,
  value: "lw62"
  text: "LW62"
,
  value: "lw63"
  text: "LW63"
,
  value: "ptt"
  text: "PT"
]

puttOptions = [
  value: PUTT_DISABLED_VALUE #putt_disabled
  text: '-'
]

_.times 16, (i) ->
  puttOptions.push
    value: i
    text: i

ob_waterOptions = []

_.times 5, (i) ->
  ob_waterOptions.push
    value: i + 1
    text: i + 1

fairwayOptions = [
  value: "center"
  text: "<div class='circle-red'></div>"
,
  value: "left"
  text: "<div class='arrow-back'></div>"
,
  value: "right"
  text: "<div class='arrow-forward'></div>"
]

sandOptions = [
  value: false
  text: "<div class='empty'></div>"
,
  value: true
  text: "<div class='check'></div>"
]

ScoreCardUIService = ->
  isParOn = (score) ->
    return false unless score.shot_cnt
    return false if score.putt_disabled
    ((score.holePar || 0) - score.shot_cnt + score.putt_cnt) >= 2

  updateShotColor = (score) ->
    item = _.find score.scoreOptions, (s) -> s.value is score.shot_cnt
    score.shotCntColor = item?.cssClass

  getScoreOptions: (holePar) ->
    _.map [1..15], (shotCnt) ->
      score = shotCnt - holePar
      item = switch score
        when -4
          scoreName: 'Condor'
          cssClass: "condor"
        when -3
          scoreName: 'Albatross'
          cssClass: 'albatross'
        when -2
          scoreName: 'Eagle'
          cssClass: 'eagle'
        when -1
          scoreName: 'Birdie'
          cssClass: 'birdie'
        when 0
          scoreName: 'Par'
          cssClass: 'par'
        when 1
          scoreName: 'Bogey'
          cssClass: 'bogey'
        when 2
          scoreName: '2 Bogey'
          cssClass: 'dbogey'
        else
          scoreName: "#{score} Bogey"
          cssClass: 'overTbogey'

      #TODO Will replace html with text property here
      value: shotCnt
      text: "#{shotCnt}<span class='sub-text'>#{item.scoreName}</span>"
      cssClass: item.cssClass

  getDefaultData: ->
    puttOptions: puttOptions
    teeOffClubOptions: teeOffClubOptions
    fairwayOptions: fairwayOptions
    ob_waterOptions: ob_waterOptions
    sandOptions: sandOptions

  updateShotCntInfo: (score) ->
    return if not score.shot_cnt
    updateShotColor(score)
    #Default value is Putt_Disabled when first choosing shot
    if not score.putt_cnt and score.putt_cnt isnt 0
      score.putt_cnt = PUTT_DISABLED_VALUE
      score.putt_disabled = true
    else if score.shot_cnt < score.putt_cnt
      #When use choose shot less than putt
      score.putt_cnt = score.shot_cnt

    score.is_par_on = isParOn(score)

  updatePuttInfo: (score) ->
    score.shot_cnt = if score.putt_cnt > score.shot_cnt then score.putt_cnt else score.shot_cnt
    updateShotColor(score)
    score.putt_disabled = score.putt_cnt is PUTT_DISABLED_VALUE
    score.is_par_on = isParOn(score)

  PUTT_DISABLED_VALUE: PUTT_DISABLED_VALUE
  PAR_VALUE_FOR_DISABLE_FAIRWAY: PAR_VALUE_FOR_DISABLE_FAIRWAY


module.exports = ScoreCardUIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-ui-service.coffee